import React, { useCallback, useEffect, useState } from "react";
import { Topbar } from "@components";
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import moment from "moment";
import { LIMITS } from "@constants";
import {
  Top,
  LightText,
  Text,
  RootContainer,
  Table,
  TableRow,
  TableCell,
  TableHeading,
  TableHeadingCell,
  SpinWrapper,
} from "./FriendList.style";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";

const { DEFAULT_PAGE, PAGE_SIZE } = LIMITS;

const FriendList = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [dataLength, setDataLength] = useState(0);

  const getFriendList = useCallback(() => {
    api
      .getFriends({
        page,
        limit: PAGE_SIZE,
      })
      .then(({ users, pagination }) => {
        setDataLength(pagination.total);
        setData((prev) => [...prev, ...users]);
        setLoading(false);
      })
      .catch((errorMsg) => {
        setLoading(false);
        message.error(errorMsg);
      });

  }, [page]);

  useEffect(() => {
    getFriendList();
  }, [getFriendList]);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
  };

  const renderTop = () => (
    <Top>
      <LightText>{t("profile.friendListHeading1")}</LightText>
      <Text>{data.length} {t("profile.friendListHeading2")}</Text>
    </Top>
  );

  return (
    <RootContainer>
      <Topbar title={t("profile.friendListTitle")} transparent={true} goBack={goBack} />
      {renderTop()}
      <InfiniteScroll
        dataLength={data.length}
        next={() => {
          setPage((prev) => prev + 1);
        }}
        hasMore={loading || data.length !== dataLength}
        loader={
          <SpinWrapper>
            <Spin size="small" />
          </SpinWrapper>
        }
      >
        <Table>
          {!loading && data.length > 0 &&
            <TableHeading>
              <TableHeadingCell>{t("profile.friendListTableHeadingNo")}</TableHeadingCell>
              <TableHeadingCell>{t("profile.friendListTableHeadingName")}</TableHeadingCell>
              <TableHeadingCell>{t("profile.friendListTableHeadingDate")}</TableHeadingCell>
              <TableHeadingCell>{t("profile.friendListTableHeadingPhone")}</TableHeadingCell>
            </TableHeading>
          }
          {data.map((friend, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{friend.name}</TableCell>
              <TableCell>
                {moment.unix(friend.created_at).format("D/MM/YYYY")}
              </TableCell>
              <TableCell>{`*******${friend.phone.substr(-4)}`}</TableCell>
            </TableRow>
          ))}
        </Table>
      </InfiniteScroll>
    </RootContainer>
  );
};

export default FriendList;
